import { render, staticRenderFns } from "./orgBinding.vue?vue&type=template&id=6d5132f6&scoped=true&"
import script from "./orgBinding.vue?vue&type=script&lang=js&"
export * from "./orgBinding.vue?vue&type=script&lang=js&"
import style0 from "./orgBinding.vue?vue&type=style&index=0&id=6d5132f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5132f6",
  null
  
)

export default component.exports